import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { PrismVolume } from '../../../../../../viewer/elements/volume/prism-volume';
import { useElementHeight } from '../../../../../hooks/use-element-height';
import { LabelledContainer } from '../../../../labelled-container/labelled-container';
import { CollapsableSection } from '../../../../skyview/right-menu/components/collapsable-section';
import { Stack } from '../../../../stack/stack';
import { TextBox } from '../../../../text-box/text-box';
import { StickySearchBox } from '../helpers/types';
import { VolumeWithAsset } from '../helpers/utils';
import { VolumeListVolumeCard } from '../helpers/volume-list-volume-card';

type Props = {
  selectedVolume?: VolumeWithAsset;
  volumesWithAssets?: VolumeWithAsset[];
  setSelectedVolume: (items: VolumeWithAsset) => void;
  loading: boolean;
};

function searchFilter(x: VolumeWithAsset, nameFilter: string) {
  if (!(x.volume instanceof PrismVolume)) {
    return false;
  }

  if (!nameFilter) {
    return true;
  }

  return (
    x.volume.name?.toLowerCase().includes(nameFilter) ||
    x.asset.name.toLowerCase().includes(nameFilter) ||
    x.sourceName?.toLowerCase().includes(nameFilter)
  );
}

export const VolumeSingleSelectListSection = (props: Props) => {
  const { t } = useTranslation();
  const [volumeSectionGroupExpanded, setVolumeSectionGroupExpanded] = React.useState(true);
  const [searchText, setSearchText] = React.useState('');
  const headerRef = useRef<HTMLDivElement>(null);
  const headerHeight = useElementHeight(headerRef);

  return (
    <CollapsableSection
      expanded={volumeSectionGroupExpanded}
      headerRef={headerRef}
      title={t('volumeListSection.prismVolumeHeader', { ns: 'skyviewReport' })}
      titleUpperCase={true}
      onSetExpanded={() => {
        setVolumeSectionGroupExpanded((expanded) => !expanded);
      }}
    >
      <StickySearchBox height={headerHeight}>
        <LabelledContainer text={t('searchHeader', { ns: 'skyviewReport' })}>
          <TextBox value={searchText} onChange={(e) => setSearchText(e.target.value)} />
        </LabelledContainer>
      </StickySearchBox>

      <Stack direction="column" spacing={0.8}>
        {props.volumesWithAssets
          ?.filter((x) => searchFilter(x, searchText.toLowerCase()))
          .map((volume: VolumeWithAsset) => {
            return (
              <VolumeListVolumeCard
                key={volume.id}
                loading={props.loading}
                selected={volume.id === props.selectedVolume?.id}
                volume={volume}
                onClick={() => {
                  if (!props.loading) {
                    props.setSelectedVolume(volume);
                  }
                }}
              />
            );
          })}
      </Stack>
    </CollapsableSection>
  );
};
